import {clearString, FullAlphabet, removeDiacritics} from "../helpers/stringHelpers";


const cachedFractions = {};
const Fractions = {
    table: function (missing) {
        let mergedMissing = missing.join('');
        if (cachedFractions[mergedMissing]) {
            return cachedFractions[mergedMissing]
        }
        let myAlphabet = FullAlphabet.filter((str) => {
            return str !== missing[0].toLowerCase().replace('ch', '*') &&
                str !== missing[1].toLowerCase().replace('ch', '*')
        })
        console.log([...myAlphabet].splice(0, 5).join(', '))
        console.log([...myAlphabet].splice(5, 5).join(', '))
        console.log([...myAlphabet].splice(10, 5).join(', '))
        console.log([...myAlphabet].splice(15, 5).join(', '))
        console.log([...myAlphabet].splice(20, 5).join(', '))
        cachedFractions[mergedMissing] = myAlphabet;
        return myAlphabet;
    }


}

const SEPARATOR = ' '
const INNER_SEPARATOR = '/'
export const methods = {
    cypher: function (input, hasCh = false, missing = ['ch', 'q'], params, sep = SEPARATOR) {
        let cyphered = []
        let cleaned = removeDiacritics(input).toLowerCase();
        if (missing.includes('ch')) {
            cleaned.replaceAll('ch', '*')
        }
        cleaned.split('').forEach((char) => {
            if (char.match(/[.,?!]/) || char.length == 0) {
                cyphered.push(char);
            } else if (char.match(/[ ]/)) {
                cyphered.push(char);
            } else {
                let index = Fractions.table(missing).indexOf(char);
                cyphered.push(`${Math.floor(index / 5) + 1}${INNER_SEPARATOR}${(index % 5) + 1}`)
            }
        })
        //console.log(cyphered);
        return cyphered.join(sep);
    },
    decypher: function (input, hasCh = false, missing = ['ch', 'q'], params, sep = SEPARATOR) {
        let deciphered = []
        let sparatorSpliter = new RegExp("[; |/"+sep+"]");
        input.split(sparatorSpliter).forEach((char) => {
            if (char.length == 0) {
                deciphered.push(' ');
            } else if (char.match(/[.,?!]/) || char.length == 0) {
                deciphered.push(char);
            } else if (char.match(/[ ]/)) {
                deciphered.push(char);
            } else {
                let [up, down] = char.split(INNER_SEPARATOR).map((a) => parseInt(a));
                deciphered.push(Fractions.table(missing)[((up - 1) * 5) + down - 1]);
            }
        });

        return deciphered.join('')
            .replaceAll('*', 'ch');
    },
};

export default {...methods,SEPARATOR}